import * as React from "react";
import { useTranslation } from "./i18n";
var GameModeE = function (props) {
    var _a = useTranslation(), lang = _a.lang, t = _a.t;
    var linkClass = "ml-2 align-middle text-sm font-semibold text-[var(--accent)] underline decoration-[var(--accent)]/40 underline-offset-2";
    var guides = (React.createElement(React.Fragment, null,
        React.createElement("a", { href: "rules.html?lang=".concat(lang), target: "_blank", rel: "noreferrer", className: linkClass }, t("gameMode.rules")),
        React.createElement("a", { href: "strategy.html?lang=".concat(lang), target: "_blank", rel: "noreferrer", className: linkClass }, t("gameMode.strategy"))));
    var isZh = lang === "zh";
    if (props.gameMode === "Tractor") {
        return (React.createElement("span", null,
            isZh && "升级 ",
            React.createElement("span", { className: "text-[var(--accent)]" }, "Tractor"),
            guides));
    }
    else {
        return (React.createElement("span", null,
            isZh && "找朋友 ",
            React.createElement("span", { className: "text-[var(--accent)]" }, "Finding Friends"),
            guides));
    }
};
export default GameModeE;
